module.exports = __webpack_public_path__ + "static/media/regal-rush-blue-bg-gold-200x100.74ec9f08.png";